module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bigDiv",
    style: ({
      'height': _vm.progress === 0 ? '0rem' : '.5rem'
    })
  }, [_c('div', {
    staticClass: "progressDiv",
    style: ({
      'width': _vm.progress + '%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "txtDiv"
  }, [_vm._v(" 已下载 " + _vm._s(_vm.progress) + " %")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f413214"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operation/exclusiveProgress.vue
// module id = 445
// module chunks = 1